export default "/fonts/poppins-v9-latin-500.svg?d81fa307305770566b96178e383badf6";